/** Step 5 “Approach”. */
const wizApproachEN = {
  wizApprTitle: 'How do we approach them?',
  wizApprSubtitle:
    'These answers determine the flow and the tone of the messages in the next step.',
  wizApprKnown: 'What I already know: {{info}} ({{name}})',
  wizApprAccountRecruiter: 'Account: Recruiter, InMail credit',
  wizApprAccountSalesNav: 'Account: Sales Navigator, InMail credit',
  wizApprAccountNormal: 'Account: LinkedIn without recognisable Premium',
  wizApprRecruitsForTitle: 'Do you recruit for your own company or as a service provider?',
  wizApprRecruitsOwn: 'Own company',
  wizApprRecruitsClients: 'As a service provider for clients',
  wizApprAudienceTitle: 'Who do you approach in this campaign?',
  wizApprAudienceNew: 'New contacts only',
  wizApprAudienceNewDesc: 'Connection request first, InMail as fallback',
  wizApprAudienceExisting: 'Existing contacts only',
  wizApprAudienceExistingDesc: 'Directly by message, no InMails',
  wizApprAudienceBoth: 'Both',
  wizApprAudienceBothDesc: 'Branch per contact at the start',
  wizApprNoteTitle: 'Connection request',
  wizApprNoteWith: 'With message',
  wizApprNoteWithDesc: 'Short note right in the request',
  wizApprNoteWithout: 'Without message',
  wizApprNoteWithoutDesc: 'First message only after acceptance',
  wizApprInmailTitle: 'If the connection request is not accepted',
  wizApprInmailWith: 'Follow up by InMail',
  wizApprInmailWithDesc: 'One InMail, then the request is withdrawn',
  wizApprInmailWithout: 'Without InMail',
  wizApprInmailWithoutDesc: 'The request is withdrawn, the InMail credit is kept',
  wizApprReferralTitle: 'Ask for a referral at the end if they are not interested themselves?',
  wizApprReferralYes: 'Yes, with referral bonus',
  wizApprReferralYesDesc: 'State the amount, it will appear in the message.',
  wizApprReferralNo: 'No',
  wizApprReferralNoDesc: 'The flow ends with the breakup message.',
  wizApprCreditTitle: 'Does this LinkedIn account have InMail credit (Premium)?',
  wizApprCreditYes: 'Yes, InMail credit available',
  wizApprCreditYesDesc: 'One InMail as a fallback if the request is not accepted',
  wizApprCreditNo: 'No',
  wizApprCreditNoDesc: 'After the waiting window the request is withdrawn',
  wizApprBonusLabel: 'Bonus, e.g. €500',
  wizApprLanguageTitle: 'Language of the messages',
  wizApprLangPrimary: 'Primary language',
  wizApprLangSecondary: 'Secondary language (optional)',
  wizApprLangDe: 'German',
  wizApprLangEn: 'English',
  wizApprLangAuto: 'Detect profile language',
  wizApprLangNone: 'None',
  wizApprLangSecondaryHint:
    'If empty, all messages are sent in the primary language. If a language is chosen here, contacts whose profile language differs from the primary one receive messages in this fallback language.',
  wizApprEmojis: 'Allow emojis',
  wizApprSwissS: 'Convert “ß” to “ss”',
  wizApprCalendar: 'Use calendar link',
  wizApprCalendarDesc:
    'Built in as a low-threshold option for concrete appointment proposals and in the breakup message.',
  wizApprCalendarPlaceholder: 'https://calendly.com/your-name/15min',
  wizApprAutoReply: 'Answer replies automatically',
  wizApprAutoReplyDesc:
    'The AI answers incoming replies from contacts based on the goal and cases. Off: as soon as someone replies, you take over.',
  wizApprAutoReplyNoCalendar:
    'Note: without a calendar link, the meeting link placeholder stays empty in the replies.',
  wizApprAutoReplyShow: 'Show auto-reply settings',
  wizApprAutoReplyHide: 'Hide settings',
  wizApprFormalityTitle: 'How do you address candidates?',
  wizApprFormalSie: 'Formal (Sie)',
  wizApprFormalSieDesc: 'Formal address (default)',
  wizApprFormalDu: 'Informal (Du)',
  wizApprFormalDuDesc: 'Personal address',
  wizApprPlaceholdersTitle: 'Custom placeholders',
  wizApprPlaceholdersHint:
    'Your own details such as benefits, salary or home office (one key + value). SAIA works each placeholder into suitable messages automatically. You can also insert them in the automatic replies, e.g. {{example}}. The calendar link above is available as {{link}}.',
  wizApprPlaceholderValueHint:
    'Add supplementary information about your search that is not in the job description, so SAIA can use it in the messages.',
  wizApprPlaceholderKeyInvalid: 'Use letters, digits and underscores, words separated by spaces (e.g. Home Office).',
  wizApprPlaceholderKeyUsed: 'This key already exists. Each placeholder has exactly one key, and each key can be used only once.',
};
export default wizApproachEN;
